module.exports = __webpack_public_path__ + "img/64.2f8a08af.png";